import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const drawerSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.drawer, {
        base: {
            header: {
                borderColor: '{colors.border}',
                pt: 4,
                px: 6,
            },
            footer: {
                borderColor: '{colors.border}',
                pt: 4,
            },
            content: {
                zIndex: 'modal',
            },
            positioner: {
                maxH: '100dvh',
                height: '100dvh',
            },
            body: {
                py: 4,
                px: 6,
                fontSize: 'md',
            },
            closeTrigger: {
                top: 0.5,
                right: 0.5,
                colorPalette: 'gray',
            },
            backdrop: {
                zIndex: 'modal',
            },
        },
        variants: {
            variant: {
                navigation: {
                    content: {
                        height: 'calc(100vh - {spacing.headerOffset})',
                        maxH: 'calc(100vh - {spacing.headerOffset})',
                        mt: 'headerOffset',
                    },
                    body: {
                        background: 'secondary.50',
                    },
                },
                withMargin: {
                    content: {
                        overflow: 'hidden',
                        height: '100vh',
                        maxH: 'calc(100% - 4rem)',
                        borderTopRadius: 'md',
                    },
                },
                contentHeight: {
                    content: {
                        // iOS issue - we need to set it to inline-block otherwise 'max-content' won't apply
                        // https://stackoverflow.com/questions/27456607/css-width-max-content-in-safari-browser
                        display: 'inline-block',
                        height: 'max-content',
                        minH: '50vh',
                        overflow: 'auto',
                        maxH: 'calc(100% - 4rem)',
                        borderTopRadius: 'md',
                    },
                    header: {
                        position: 'sticky',
                        background: 'white',
                        top: 0,
                    },
                    body: {
                        minH: 'calc(50vh - 7rem)',
                    },
                },
                overlap: {
                    content: {
                        maxH: 'calc(100% - 4rem)',
                        borderTopRadius: '12px',
                        height: '100vh',
                    },
                    // override container to overlap accommodation sticky bar
                    positioner: {
                        zIndex: 'calc({zIndex.modal} + 2)',
                    },
                },

                autoHeight: {
                    content: {
                        h: 'auto',
                        maxH: 'calc(100% - 4rem)',
                        borderTopRadius: 'md',
                    },
                    header: {
                        borderTopRadius: 'inherit',
                    },
                },
            },
            size: {
                md: {
                    content: {
                        maxW: '650px',
                    },
                },
            },
        },
    }),
);
